import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { PersonService } from '../../service/person.service';
import { ActivatedRoute } from '@angular/router'
import { UserInfoModel } from '../../model/user.model';

@Component({
    selector: 'app-personal-data',
    templateUrl: './personal-data.component.html',
    styleUrls: ['../../share/modal/modal.component.styl', './personal-data.component.styl']
})
export class PersonalDataComponent implements OnInit{
    isLogin: boolean;
    userName: any;
    userInfo: UserInfoModel = new UserInfoModel();
    memberType: string[] = ['High School', 'College/University', 'Organization'];
    qualifications: string[] = ['CEEB', 'IB', 'WASC', 'NAIS', 'Others'];
    updateInfoForm: FormGroup;
    showModal: boolean = false;
    highschool: boolean = true;
    errMsg: string;

    constructor(
        private formBuilder: FormBuilder,
        private personService: PersonService,
        private route: ActivatedRoute
    ){}

    ngOnInit(){
        this.getUserInfo();  
    }

    // 获取用户信息
    getUserInfo(){
        this.personService.getUserInfo().subscribe(res => {
            if (res.ok){
                this.userInfo = new UserInfoModel(res.data);
                this.updateInfoForm = this.formBuilder.group({
                    email: this.userInfo.email || '',
                    memberType: this.userInfo.memberType,
                    lastName: this.userInfo.lastName || '',
                    firstName: this.userInfo.firstName || '',
                    school: this.userInfo.school || '',
                    job: this.userInfo.job || '',
                    qualifications: this.userInfo.qualifications || '',
                    code: this.userInfo.code || '',
                });
                if (this.userInfo.memberType == 0) {
                    this.highschool = true
                } else {
                    this.highschool = false
                }
                 
                const modeType = this.route.snapshot.queryParams.data  
                if (modeType === 'isRenew') {
                    this.showModal = true
                }

            }else{
                this.isLogin = false;
            }
        });
    }

    // input 清除值
    inputClear(controlName: string){
        this.updateInfoForm.get(controlName).setValue('');
    }

    // 关闭弹窗
    closeModal(){
        this.showModal = false;
        this.errMsg = '';
    }

    // 提交信息
    submit(isUpdate: boolean){
        const info = isUpdate ? this.updateInfoForm.value : this.userInfo;
        const params = {
            email: info.email,
            userRole: +info.memberType,
            firstName: info.firstName,
            lastName: info.lastName,
            school: info.school,
            job: info.job,
            codeType: this.highschool ? info.qualifications : 'Others',
            code: this.highschool ? info.code : '000000'
        };
        this.personService.userInfoRenew(params).subscribe(res => {
            if (res.status === 200){
                this.closeModal();
            }else{
                this.errMsg = res.msg;
            }
        });
    }
    //
    checkType(){
        if (this.updateInfoForm.value.memberType == 0) {
            this.highschool = true
        } else {
            this.highschool = false
        }
    }
}


// WEBPACK FOOTER //
// /Users/apple/Documents/object/chinaicac-portal/src/app/person/personal-data/personal-data.component.ts